import React from "react";

export const DashboardIcon = ({color = 'white', ...props}: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.17483 0.755245C7.17483 0.33986 6.83496 0 6.41958 0H0.755245C0.33986 0 0 0.33986 0 0.755245V8.30769C0 8.72308 0.33986 9.06294 0.755245 9.06294H6.41958C6.83496 9.06294 7.17483 8.72308 7.17483 8.30769V0.755245Z" fill={color}/>
      <path d="M19.6366 0.755245C19.6366 0.33986 19.2967 0 18.8814 0H9.44079C9.02541 0 8.68555 0.33986 8.68555 0.755245V8.30769C8.68555 8.72308 9.02541 9.06294 9.44079 9.06294H18.8814C19.2967 9.06294 19.6366 8.72308 19.6366 8.30769V0.755245Z" fill={color}/>
      <path d="M13.2172 19.6364H18.8815C19.2969 19.6364 19.6367 19.2966 19.6367 18.8812V11.3287C19.6367 10.9133 19.2969 10.5735 18.8815 10.5735H13.2172C12.8018 10.5735 12.4619 10.9133 12.4619 11.3287V18.8812C12.4619 19.2966 12.8018 19.6364 13.2172 19.6364Z" fill={color}/>
      <path d="M10.1958 10.5735H0.755245C0.33986 10.5735 0 10.9133 0 11.3287V18.8812C0 19.2966 0.33986 19.6364 0.755245 19.6364H10.1958C10.6112 19.6364 10.951 19.2966 10.951 18.8812V11.3287C10.951 10.9133 10.6112 10.5735 10.1958 10.5735Z" fill={color}/>
    </svg>
  );
};

export const UsersIcon = ({color = 'white', ...props}: any) => {
  return (
    <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M10.9871 3.8779C10.9871 6.01961 9.25087 7.7558 7.10917 7.7558C4.96746 7.7558 3.23127 6.01961 3.23127 3.8779C3.23127 1.7362 4.96746 0 7.10917 0C9.25087 0 10.9871 1.7362 10.9871 3.8779ZM10.6642 9.69476H3.55474C1.59382 9.69476 0 11.2886 0 13.2495V15.1885C0 15.7236 0.434325 16.1579 0.969475 16.1579H13.2495C13.7846 16.1579 14.219 15.7236 14.219 15.1885V13.2495C14.219 11.2886 12.6252 9.69476 10.6642 9.69476ZM22.76 13.465H15.3911V12.8505C15.3911 10.9118 14.0865 9.27347 12.3086 8.76694C12.8411 8.0463 13.7263 7.57406 14.727 7.57406H20.6179C22.2427 7.57406 23.5633 8.81923 23.5633 10.3512V12.7076C23.5633 13.1257 23.2035 13.465 22.76 13.465ZM17.2523 5.89091C18.879 5.89091 20.1977 4.57218 20.1977 2.94545C20.1977 1.31872 18.879 0 17.2523 0C15.6255 0 14.3068 1.31872 14.3068 2.94545C14.3068 4.57218 15.6255 5.89091 17.2523 5.89091Z" fill={color} />
    </svg>
  );
};

export const PaymentIcon = ({color = 'white',...props}: any) => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M9.48849 0C12.1111 0 14.3461 0.919571 16.1935 2.75871C18.0574 4.6226 18.9893 6.86585 18.9893 9.48849C18.9893 12.1194 18.0574 14.3544 16.1935 16.1935C14.3461 18.0574 12.1111 18.9893 9.48849 18.9893C6.86585 18.9893 4.6226 18.0574 2.75871 16.1935C0.919571 14.3544 0 12.1194 0 9.48849C0 6.86585 0.919571 4.6226 2.75871 2.75871C4.6226 0.919571 6.86585 0 9.48849 0ZM10.1928 3.06808H8.78247V4.55259C7.36394 4.90722 6.55158 5.64948 6.3454 6.77935C6.2052 7.90098 6.56808 8.79581 7.43404 9.46384C7.72269 9.69477 8.4732 10.0494 9.68554 10.5277C10.5598 10.8576 10.968 11.3071 10.9103 11.8762C10.836 12.5442 10.3206 12.8741 9.3639 12.8658C8.72886 12.8493 7.96599 12.5071 7.07528 11.8391L6.11035 13.039C6.30004 13.3937 6.64642 13.7029 7.14951 13.9669C7.64434 14.2308 8.18866 14.4081 8.78247 14.4988L8.79484 15.9586H10.2546L10.267 14.4864C11.3969 14.2308 12.1474 13.6452 12.5185 12.7298C12.8649 11.6246 12.7989 10.7875 12.3205 10.2185C11.8505 9.64941 11.2402 9.23292 10.4897 8.96901L9.35153 8.57314C8.90618 8.35046 8.61752 8.16077 8.48557 8.00408C7.94949 7.34429 8.04434 6.78348 8.7701 6.32163C9.68554 5.89277 10.6711 6.1237 11.7267 7.0144L12.5061 5.6536C12.036 5.01031 11.2649 4.64743 10.1928 4.56496V3.06808Z" fill={color}/>
    </svg>
  );
};

export const NextPayout = ({color = '#3A5277',...props}: any) => {
  return (
    <svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M21.0441 13.1232H21.1969C21.3221 13.1156 21.4466 13.0994 21.5696 13.0748C21.952 13.0174 22.2777 12.7665 22.4306 12.4113C22.6682 11.9486 22.5555 11.3832 22.1585 11.0471C21.9937 10.8742 21.8099 10.7204 21.6106 10.5886C21.5137 10.5216 21.4093 10.4545 21.2975 10.3911C20.9291 10.1827 20.5438 10.0056 20.1458 9.86181C19.9631 9.79472 19.773 9.73881 19.5867 9.6829H19.5382C19.1538 9.59589 18.7618 9.54719 18.3678 9.53753H18.1963H17.8609H17.5925L16.9402 9.50025C15.4903 9.38843 13.977 9.03433 13.977 7.39057C13.9554 6.84188 14.1945 6.31528 14.6218 5.97044C15.1866 5.59904 15.8552 5.41754 16.5302 5.45234C17.096 5.45392 17.6599 5.51894 18.2113 5.64616C18.2867 5.66474 18.3545 5.70645 18.4051 5.76544C19.088 6.50377 19.9435 7.06092 20.895 7.38684L21.182 7.49121C21.1984 7.47289 21.2158 7.45547 21.2341 7.43902L21.305 7.3682L21.3385 7.33839L21.4093 7.26757L21.6591 7.0402L21.7224 6.98429L21.7597 6.95074L21.9573 6.79792L22.1324 6.66746L22.1846 6.63019L22.2443 6.58919L22.5275 6.40655L22.658 6.34318C22.7586 6.28354 22.8667 6.22391 22.9711 6.17172L23.0717 6.11954C23.2059 6.05617 23.3401 5.99654 23.4817 5.94063L23.5861 5.89962L23.806 5.8139C22.2157 4.47531 20.4406 3.37309 18.5355 2.54127C17.8685 2.23211 17.1514 2.04526 16.4184 1.98962C15.3673 1.98962 13.3172 2.36236 11.1442 2.76491C8.8854 3.17865 6.5558 3.6073 5.03131 3.67066V10.5327C5.77256 10.7527 6.47996 11.0738 7.13354 11.4869L7.31246 11.5913C8.25202 12.2016 9.28975 12.6455 10.3801 12.9033C11.9157 13.2537 14.1074 13.373 17.5813 12.963C18.0882 12.9109 18.599 12.9109 19.1058 12.963L19.7246 13.0226H19.8401H19.8923C20.2017 13.0562 20.5073 13.0822 20.7906 13.0897C20.88 13.1307 20.9583 13.127 21.0441 13.1232Z" fill="#3A5277"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M25.0137 6.28728C25.3338 6.2318 25.6579 6.20189 25.9828 6.19783C28.7229 6.19251 31.1071 8.07206 31.7416 10.7378C31.8505 11.1882 31.9068 11.6497 31.9093 12.1131C31.9075 15.0276 29.7781 17.5041 26.8969 17.9427C24.0156 18.3813 21.2458 16.6506 20.3768 13.8687H20.6825H20.7943H20.9024H21.2304H21.3497C21.4749 13.8594 21.5994 13.842 21.7224 13.8166C21.8191 13.7928 21.9138 13.7616 22.0057 13.7234C22.3423 13.6027 22.6355 13.3848 22.8481 13.0972C22.9421 12.9828 23.0222 12.8577 23.0866 12.7244C23.1637 12.5573 23.2176 12.3805 23.2469 12.1989C23.3343 11.5773 23.1148 10.952 22.658 10.5216C22.4653 10.3041 22.2476 10.1101 22.0094 9.94382L21.8566 9.84691L21.6889 9.73882L21.5845 9.67918L21.331 9.545H21.3087L21.2006 9.49281L21.1037 9.44808L20.9322 9.36608L20.8018 9.31017H20.7831C20.9993 8.90803 21.262 8.53272 21.5659 8.19196C21.6404 8.10251 21.7261 8.01678 21.8081 7.93478L21.8081 7.93478L21.8864 7.85277C22.4548 7.30499 23.1263 6.8755 23.8619 6.5892C24.1289 6.48639 24.403 6.40293 24.6819 6.33947C24.7016 6.33539 24.7214 6.33107 24.7414 6.32673C24.8308 6.30723 24.9222 6.28728 25.0137 6.28728ZM27.6803 12.4113C27.434 11.9846 26.9787 11.7218 26.486 11.7218H26.4189V10.4582H26.4972C26.6652 10.4582 26.8264 10.525 26.9452 10.6438C27.064 10.7626 27.1308 10.9238 27.1308 11.0918H27.8651C27.8651 10.3302 27.2476 9.71273 26.486 9.71273H26.4077V9.0828H25.6622V9.70154H25.4796C24.7468 9.73968 24.1721 10.345 24.1721 11.0788C24.1721 11.8126 24.7468 12.4179 25.4796 12.4561H25.6622V13.7234H25.4796C25.2652 13.7228 25.0658 13.6133 24.9503 13.4326C24.8847 13.3303 24.8498 13.2113 24.8497 13.0897H24.1042C24.1042 13.8499 24.7194 14.4668 25.4796 14.4688H25.6622V15.1099H26.4077V14.48H26.486C26.9787 14.48 27.434 14.2172 27.6803 13.7905C27.9267 13.3638 27.9267 12.838 27.6803 12.4113Z" fill="#3A5277"/>
      <path d="M24.9578 10.7415C24.8877 10.8463 24.8501 10.9695 24.8497 11.0956C24.8497 11.4435 25.1317 11.7255 25.4796 11.7255H25.6622V10.4582H25.4796C25.2693 10.4596 25.0735 10.5658 24.9578 10.7415Z" fill="#3A5277"/>
      <path d="M27.1308 13.1009C27.1308 12.7509 26.8471 12.4672 26.4972 12.4672H26.4189V13.7233H26.4972C26.8428 13.7234 27.1247 13.4465 27.1308 13.1009Z" fill="#3A5277"/>
      <rect x="0.0142822" y="2.43317" width="2.95952" height="9.28858" fill={color}/>
    </svg>
  );
};

export const ArrowDown = ({color = '#687A9E',...props}: any) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} >
      <path d="M7.41 8.59003L12 13.17L16.59 8.59003L18 10L12 16L6 10L7.41 8.59003Z" fill={color} />
    </svg>
  );
};

export const DateIcon = ({color = '#687A9E',...props}: any) => {
  return (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16 3H15V2C15 1.73478 14.8946 1.48043 14.7071 1.29289C14.5196 1.10536 14.2652 1 14 1C13.7348 1 13.4804 1.10536 13.2929 1.29289C13.1054 1.48043 13 1.73478 13 2V3H7V2C7 1.73478 6.89464 1.48043 6.70711 1.29289C6.51957 1.10536 6.26522 1 6 1C5.73478 1 5.48043 1.10536 5.29289 1.29289C5.10536 1.48043 5 1.73478 5 2V3H4C3.20435 3 2.44129 3.31607 1.87868 3.87868C1.31607 4.44129 1 5.20435 1 6V18C1 18.7956 1.31607 19.5587 1.87868 20.1213C2.44129 20.6839 3.20435 21 4 21H16C16.7956 21 17.5587 20.6839 18.1213 20.1213C18.6839 19.5587 19 18.7956 19 18V6C19 5.20435 18.6839 4.44129 18.1213 3.87868C17.5587 3.31607 16.7956 3 16 3ZM4 5H5V6C5 6.26522 5.10536 6.51957 5.29289 6.70711C5.48043 6.89464 5.73478 7 6 7C6.26522 7 6.51957 6.89464 6.70711 6.70711C6.89464 6.51957 7 6.26522 7 6V5H13V6C13 6.26522 13.1054 6.51957 13.2929 6.70711C13.4804 6.89464 13.7348 7 14 7C14.2652 7 14.5196 6.89464 14.7071 6.70711C14.8946 6.51957 15 6.26522 15 6V5H16C16.2652 5 16.5196 5.10536 16.7071 5.29289C16.8946 5.48043 17 5.73478 17 6V10H3V6C3 5.73478 3.10536 5.48043 3.29289 5.29289C3.48043 5.10536 3.73478 5 4 5ZM16 19H4C3.73478 19 3.48043 18.8946 3.29289 18.7071C3.10536 18.5196 3 18.2652 3 18V12H17V18C17 18.2652 16.8946 18.5196 16.7071 18.7071C16.5196 18.8946 16.2652 19 16 19Z" fill="#687A9E" stroke="#F6F8FB" strokeWidth="0.6"/>
    </svg>
  );
};

export const ActiveIcon = ({color = '#F0F6FD',...props}: any) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="40" height="40" rx="8" fill={color}/>
      <path d="M28 16H12V14H28V16ZM26 10H14V12H26V10ZM30 20V28C30 29.1 29.1 30 28 30H12C10.9 30 10 29.1 10 28V20C10 18.9 10.9 18 12 18H28C29.1 18 30 18.9 30 20ZM24 24L18 20.73V27.26L24 24Z" fill="#3A5277"/>
    </svg>
  );
};

export const LikeIcon = ({color = '#F0F6FD',...props}: any) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="40" height="40" rx="8" fill={color}/>
      <path d="M21.11 13.72L20.54 16.61C20.42 17.2 20.58 17.81 20.96 18.27C21.34 18.73 21.9 19 22.5 19H28V20.08L25.43 26H17.34C17.16 26 17 25.84 17 25.66V17.82L21.11 13.72ZM22 10L15.59 16.41C15.21 16.79 15 17.3 15 17.83V25.66C15 26.95 16.05 28 17.34 28H25.44C26.15 28 26.8 27.63 27.16 27.03L29.83 20.88C29.94 20.63 30 20.36 30 20.08V19C30 17.9 29.1 17 28 17H22.5L23.42 12.35C23.47 12.13 23.44 11.89 23.34 11.69C23.11 11.24 22.82 10.83 22.46 10.47L22 10ZM12 17H10V28H12C12.55 28 13 27.55 13 27V18C13 17.45 12.55 17 12 17Z" fill="#3A5277"/>
    </svg>
  );
};

export const SignUpIcon = ({color = '#F0F6FD',...props}: any) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="40" height="40" rx="8" fill="#F0F6FD"/>
      <path d="M24 29V27C24 25.9391 23.5786 24.9217 22.8284 24.1716C22.0783 23.4214 21.0609 23 20 23H13C11.9391 23 10.9217 23.4214 10.1716 24.1716C9.42143 24.9217 9 25.9391 9 27V29" stroke="#3A5277" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M28 16V22" stroke="#3A5277" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M31 19H25" stroke="#3A5277" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.5 19C18.7091 19 20.5 17.2091 20.5 15C20.5 12.7909 18.7091 11 16.5 11C14.2909 11 12.5 12.7909 12.5 15C12.5 17.2091 14.2909 19 16.5 19Z" stroke="#3A5277" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export const LogInIcon = ({color = '#F0F6FD',...props}: any) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="40" height="40" rx="8" fill="#F0F6FD"/>
      <path d="M19 15L17.6 16.4L20.2 19H10V21H20.2L17.6 23.6L19 25L24 20L19 15ZM28 27H20V29H28C29.1 29 30 28.1 30 27V13C30 11.9 29.1 11 28 11H20V13H28V27Z" fill="#3A5277"/>
    </svg>    
  );
};

export const EarningsIcon = ({color = '#F0F6FD',...props}: any) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="40" height="40" rx="8" fill="#F0F6FD"/>
      <path d="M18 17.5C18 16.8345 18.717 16 20 16C20.7222 16 21.3152 16.2899 21.6574 16.6695C22.0272 17.0798 22.6595 17.1126 23.0697 16.7428C23.48 16.373 23.5128 15.7407 23.143 15.3305C22.5982 14.7261 21.8451 14.2994 21 14.11V13C21 12.4477 20.5523 12 20 12C19.4477 12 19 12.4477 19 13V14.1134C17.3684 14.4865 16 15.7529 16 17.5C16 19.596 17.9693 21 20 21C21.283 21 21.9998 21.8345 21.9998 22.5C21.9998 23.1655 21.2829 24 19.9998 24C19.2776 24 18.6846 23.7101 18.3424 23.3305C17.9726 22.9202 17.3403 22.8874 16.9301 23.2572C16.5199 23.627 16.4871 24.2593 16.8568 24.6695C17.4016 25.274 18.1548 25.7006 19 25.8901V27C19 27.5523 19.4477 28 20 28C20.5523 28 21 27.5523 21 27V25.8866C22.6316 25.5134 23.9998 24.2471 23.9998 22.5C23.9998 20.404 22.0307 19 20 19C18.717 19 18 18.1655 18 17.5Z" fill="#3A5277"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M32 20C32 26.6274 26.6274 32 20 32C13.3726 32 8 26.6274 8 20C8 13.3726 13.3726 8 20 8C26.6274 8 32 13.3726 32 20ZM30 20C30 25.5228 25.5228 30 20 30C14.4772 30 10 25.5228 10 20C10 14.4772 14.4772 10 20 10C25.5228 10 30 14.4772 30 20Z" fill="#3A5277"/>
    </svg>
  );
};

export const UserPaymentIcon = ({color = '#F0F6FD',...props}: any) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="40" height="40" rx="8" fill="#F0F6FD"/>
      <g clipPath="url(#clip0)">
      <path d="M19 18.214C19 17.8837 19.3381 17.4283 20 17.4283C20.3707 17.4283 20.6673 17.5872 20.8349 17.7864C21.1905 18.209 21.8213 18.2634 22.2439 17.9078C22.6665 17.5523 22.7209 16.9215 22.3654 16.4989C22.0113 16.078 21.537 15.7626 21 15.5868V14.9998C21 14.4475 20.5523 13.9998 20 13.9998C19.4477 13.9998 19 14.4475 19 14.9998V15.5898C17.8802 15.9597 17 16.9359 17 18.214C17 19.8561 18.4527 20.9998 20 20.9998C20.6619 20.9998 21 21.4552 21 21.7856C21 22.116 20.6619 22.5713 20 22.5713C19.6293 22.5713 19.3327 22.4125 19.1651 22.2132C18.8096 21.7906 18.1788 21.7362 17.7561 22.0918C17.3335 22.4473 17.2791 23.0781 17.6347 23.5008C17.9887 23.9216 18.463 24.237 19 24.4128V24.9999C19 25.5521 19.4477 25.9999 20 25.9999C20.5523 25.9999 21 25.5521 21 24.9999V24.4098C22.1198 24.0399 23 23.0637 23 21.7856C23 20.1435 21.5473 18.9998 20 18.9998C19.3381 18.9998 19 18.5444 19 18.214Z" fill="#3A5277"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M28.2929 9.29289C28.6834 8.90237 29.3166 8.90237 29.7071 9.29289L31.7071 11.2929C32.0976 11.6834 32.0976 12.3166 31.7071 12.7071L29.7071 14.7071C29.3166 15.0976 28.6834 15.0976 28.2929 14.7071C27.9024 14.3166 27.9024 13.6834 28.2929 13.2929L28.5858 13H25.6573C27.6963 14.65 29 17.1727 29 20C29 24.9706 24.9706 29 20 29H11.4142L11.7071 29.2929C12.0976 29.6834 12.0976 30.3166 11.7071 30.7071C11.3166 31.0976 10.6834 31.0976 10.2929 30.7071L8.29289 28.7071C7.90237 28.3166 7.90237 27.6834 8.29289 27.2929L10.2929 25.2929C10.6834 24.9024 11.3166 24.9024 11.7071 25.2929C12.0976 25.6834 12.0976 26.3166 11.7071 26.7071L11.4142 27H14.3427C12.3037 25.35 11 22.8273 11 20C11 15.0294 15.0294 11 20 11H28.5858L28.2929 10.7071C27.9024 10.3166 27.9024 9.68342 28.2929 9.29289ZM20 27C23.866 27 27 23.866 27 20C27 16.134 23.866 13 20 13C16.134 13 13 16.134 13 20C13 23.866 16.134 27 20 27Z" fill="#3A5277"/>
      </g>
      <defs>
      <clipPath id="clip0">
      <rect width="24" height="24" fill="white" transform="translate(8 8)"/>
      </clipPath>
      </defs>
    </svg>
  );
};

export const ClientsIcon = (props: any) => {
  return (
    <svg
      width={24}
      height={23}
      viewBox="0 3 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23 21v-2a4 4 0 00-3-3.87M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M16 3.13a4 4 0 010 7.75M9 11a4 4 0 100-8 4 4 0 000 8z"
        stroke="#3A5277"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserIcon = ({color = "#3A5277", opacity = '0.8',...props}: any) => {
  return (
    <svg
      width={24}
      height={23}
      viewBox="0 3 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z"
        stroke={color}
        strokeOpacity={opacity}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VideoIcon = (props: any) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23 7l-7 5 7 5V7zM14 5H3a2 2 0 00-2 2v10a2 2 0 002 2h11a2 2 0 002-2V7a2 2 0 00-2-2z"
        stroke="#3A5277"
        strokeOpacity={0.8}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = (props: any) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        opacity={0.8}
        stroke="#2C2E39"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35" />
      </g>
    </svg>
  );
};

export const OptionIcon = (props: any) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 13a1 1 0 100-2 1 1 0 000 2zM12 6a1 1 0 100-2 1 1 0 000 2zM12 20a1 1 0 100-2 1 1 0 000 2z"
        stroke="#687A9E"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DecreaseIcon = (props: any) => {
  return (
    <svg width={33} height={21} viewBox="0 0 34 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      fill-rule="evenodd" 
      clip-rule="evenodd"
      d="M24.5 18.5C23.6716 18.5 23 19.1716 23 20C23 20.8284 23.6716 21.5 24.5 21.5H32C32.8284 21.5 33.5 20.8284 33.5 20V12.5C33.5 11.6716 32.8284 11 32 11C31.1716 11 30.5 11.6716 30.5 12.5V16.3787L19.5607 5.43934C18.9749 4.85355 18.0251 4.85355 17.4393 5.43934L12.5 10.3787L3.06066 0.939341C2.47487 0.353554 1.52513 0.353554 0.93934 0.939341C0.353553 1.52513 0.353553 2.47487 0.93934 3.06066L11.4393 13.5607C12.0251 14.1464 12.9749 14.1464 13.5607 13.5607L18.5 8.62132L28.3787 18.5H24.5Z"
      fill="#F86D6D"/>
    </svg>
  )
}

export const IncreaseIcon = (props: any) => {
  return (
    <svg width={33} height={21} viewBox="0 0 34 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      fill-rule="evenodd" 
      clip-rule="evenodd" 
      d="M24.5 3.5C23.6716 3.5 23 2.82843 23 2C23 1.17157 23.6716 0.5 24.5 0.5H32C32.8284 0.5 33.5 1.17157 33.5 2V9.5C33.5 10.3284 32.8284 11 32 11C31.1716 11 30.5 10.3284 30.5 9.5V5.62132L19.5607 16.5607C18.9749 17.1464 18.0251 17.1464 17.4393 16.5607L12.5 11.6213L3.06066 21.0607C2.47487 21.6464 1.52513 21.6464 0.93934 21.0607C0.353553 20.4749 0.353553 19.5251 0.93934 18.9393L11.4393 8.43934C12.0251 7.85355 12.9749 7.85355 13.5607 8.43934L18.5 13.3787L28.3787 3.5H24.5Z" 
      fill="#37DDB4"/>
    </svg>
  )
}

export const RadiationIcon = (props: any) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" stroke="#3A5277" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16.24 7.75999C16.7979 8.31723 17.2404 8.97896 17.5424 9.70735C17.8443 10.4357 17.9997 11.2165 17.9997 12.005C17.9997 12.7935 17.8443 13.5742 17.5424 14.3026C17.2404 15.031 16.7979 15.6928 16.24 16.25M7.76 16.24C7.20214 15.6828 6.75959 15.021 6.45764 14.2926C6.1557 13.5642 6.00028 12.7835 6.00028 11.995C6.00028 11.2065 6.1557 10.4257 6.45764 9.69735C6.75959 8.96896 7.20214 8.30723 7.76 7.74999M19.07 4.92999C20.9447 6.80527 21.9979 9.34835 21.9979 12C21.9979 14.6516 20.9447 17.1947 19.07 19.07M4.93 19.07C3.05529 17.1947 2.00214 14.6516 2.00214 12C2.00214 9.34835 3.05529 6.80527 4.93 4.92999" stroke="#3A5277" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export const TipsIcon = (props: any) => {
  return(
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#CABAE6"/>
    </svg>
  )
}

export const SubscriptionIcon = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#80DEEA"/>
    </svg>
  )
}
export const TrafficIcon = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="9" fill="#5C39FF" stroke="#F8FAFD" stroke-width="2"/>
    </svg>

  )
}

export const RefferalIcon = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#3CC23A" stroke="#F8FAFD" stroke-width="2"/>
    </svg>

  )
}

export const OrganicIcon = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#CF2929" stroke="#F8FAFD" stroke-width="2"/>
    </svg>

  )
}

export const FreeSubscriptionIcon = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#90CBF9" stroke="#F8FAFD" stroke-width="2"/>
    </svg>
  )
}



export const PostsIcon = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#F5A0BD" stroke="#F8FAFD" stroke-width="2"/>
    </svg>

  )
}

export const LikesIcon = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#FFB8A1" stroke="#F8FAFD" stroke-width="2"/>
    </svg>
  )
}

export const SharesIcon = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="10" fill="#FFA000" stroke="#F8FAFD" stroke-width="2"/>
    </svg>
  )
}

export const ClicksIcon = (props: any) => {
  return (
   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
   <circle cx="10" cy="10" r="10" fill="#C4C4C4" stroke="#F8FAFD" stroke-width="2"/>
   </svg>
  )
}

export const ActivityIcon = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M10 5C7.24 5 5 7.24 5 10C5 12.76 7.24 15 10 15C12.76 15 15 12.76 15 10C15 7.24 12.76 5 10 5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z" fill="#672FD4"/>
    </svg>

  )
}

export const PassiveIcon = (props: any) => {
  return (
   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z" fill="#B3BED1"/>
   </svg>

  )
}

